import { type App, createApp, type Component } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faCircleNotch,
  faLock,
  faMoon,
  faSun,
  faCircleExclamation,
  faTriangleExclamation,
  faCircleInfo,
  faCircleCheck,
  faGlobeAmericas,
  faSyncAlt,
  faClock,
  faSearch,
  faTimes,
  faQuestionCircle,
  faChevronRight,
  faChevronLeft,
  faLockOpen,
  faEdit,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { createBootstrap } from 'bootstrap-vue-next';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import LaddaButton from '@stl/components/LaddaButton.vue';
import VSpinner from '@stl/components/VSpinner.vue';
import CopyButton from '@stl/components/CopyButton.vue';
import PageHeader from '@stl/components/PageHeader.vue';
import PageContent from '@stl/components/PageContent.vue';
import { installFilters } from './filters';
import Confirm from './plugins/confirm';
import AlertBox from '@stl/components/AlertBox.vue';

export function CreateApp(component: Component): App<Element> {
  const app = createApp(component);

  return InitializeApp(app);
}

export function InitializeApp(app: App<Element>): App<Element> {
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);

  library.add(
    faMoon,
    faSun,
    faLock,
    faAngleDown,
    faCopy,
    faCircleNotch,
    faCircleExclamation,
    faTriangleExclamation,
    faCircleInfo,
    faCircleCheck,
    faGlobeAmericas,
    faSyncAlt,
    faClock,
    faSearch,
    faTimes,
    faQuestionCircle,
    faChevronRight,
    faChevronLeft,
    faLockOpen,
    faEdit,
    faTrashAlt
  );

  installFilters(app);

  //n.b.: if globally registering a component, also add it to vue.d.ts file
  return app
    .use(pinia)
    .use(createBootstrap())
    .use(Confirm)
    .component('VSpinner', VSpinner)
    .component('LaddaButton', LaddaButton)
    .component('CopyButton', CopyButton)
    .component('PageHeader', PageHeader)
    .component('PageContent', PageContent)
    .component('AlertBox', AlertBox)
    .component('FontAwesomeIcon', FontAwesomeIcon);
}
